import Client from "../Client";
import Exceptions from "../Exceptions";
import { addAttraction, deleteAttraction, getAttractionList, getLGUList, getProvinceList, updateAttraction } from "../services/api/meta";
import { AlertDrawerController } from "../views/sections/sidebar/AlertDrawer";
import { Notifier } from "./conductor";
import { showModal } from "../views/widgets/modal";
import { AttractionFactory } from "../views/widgets/modals/attraction";
import { Button } from "../views/widgets/buttons";
import { listToCollection } from "../misc/object";


export class AttractionsController {
    constructor(options) {

        /** @type {{ lgu: string, id: string }} */
        this.reference = options.ref;

        const self = this;        
        this.notifiers = {
            ready: new Notifier(false),
            unauthorized: new Notifier(false),
            reloading: new Notifier(false),
            reloaded: new Notifier(),
            alert: new AlertDrawerController(),
            adding: new Notifier(false)
        };

        this.status = {
            get ready() { return self.notifiers.ready.get() },
            get reloading() { return self.notifiers.reloading.get() },
            get adding() { return self.notifiers.adding.get() },
            get unauthorized() { return self.notifiers.unauthorized.get() }
        };

        this.initialize();
    }

    async initialize() {
        Client.ensureSignedIn();
        if(this.isInitialized) return; this.isInitialized = true;

        try {
            this.collection = {
                province: listToCollection(await getProvinceList()),
                lgu: listToCollection(await getLGUList())
            };
            
            await this.loadData();
        } catch(e) {
            if(e.unauthorized) return this.notifiers.unauthorized.update(true);
        }
        
        this.notifiers.ready.update(true);
    }

    async loadData() {
        const { province, lgu } = this.reference;
        if(lgu) {
           this.data = await getAttractionList(lgu);

           this.data.forEach(attraction => {
                if(!attraction.lgu) attraction.lgu = lgu;

                const lguId = attraction.lgu;
                const lguValues = this.collection.lgu[lguId];

                if(lguValues) {
                    const province = this.collection.province[lguValues.province];
                    attraction.location = `${lguValues.name}, ${province.name}`;
                }
           });
        } else this.data = [];
        // const { province, month, year } = this.reference;
        // this.data = await getProvinceVisitsSubmissions({ province, month, year });
    }

    async refresh(closeAlert = true) {
        const { reloading, reloaded, alert } = this.notifiers;
        reloading.update(true);
        if(closeAlert) alert.close();

        try {
            await this.loadData();
            reloaded.notify();
        } catch(e) {
            const semantics = Exceptions.getARESemantics(e);
            alert.alert(semantics.message, { status: "error", title: semantics.title, retry: () => this.refresh() });
        }

        reloading.update(false);
    }
    
    async changeLocation(province, lgu) {
        this.reference.province = province;
        this.reference.lgu = lgu;
        await this.refresh();

        // MainRouter.pushPath(`/forms/sameday/province/${this.reference.province}/submissions/${month}/${year}`);
    }

    getProvinces() { return Object.values(this.collection.province) };
    getLGUs(province) {
        const lgus = Object.values(this.collection.lgu)
            .filter(lgu => lgu.province === province);

        return lgus;
    };


    async addAttraction() {
        const { notifiers: { alert, adding } } = this;
        const addable = await addOrEditAttraction(null, { 
            lgu: this.reference.lgu, collection: this.collection });

        if(addable) {
            adding.update(true);
            alert.alert("Adding attraction...", { status: "progress" });

            try {
                await addAttraction(addable);
                alert.alert("Attraction added successfully!");
            } catch(e) {
                const { title, message } = Exceptions.getARESemantics(e);
                alert.alert(message, { title, status: "error" });
            }


            this.refresh(false);
            adding.update(false);
        }
    }

    async editAttraction(attraction) {
        const { notifiers: { alert } } = this;
        const updated = await addOrEditAttraction(attraction, { 
            lgu: this.reference.lgu, collection: this.collection });

        if(updated) {
            alert.alert("Updating attraction...", { status: "progress" });

            try {
                await updateAttraction(updated);
                alert.alert("Attraction updated successfully!");
            } catch(e) {
                const { title, message } = Exceptions.getARESemantics(e);
                alert.alert(message, { title, status: "error" });
            }

            this.refresh(false);
        }
    }

    async deleteAttraction(attraction) {
        const { notifiers: { alert } } = this;

        const returned = await showModal({ 
            title: "Verify Deletion",
            titleColor: "red",
            body: <span>
                You are about to <b>delete</b> the attraction <b>{attraction.name}</b>. 
                Please confirm this action by  
                <b> typing in the password</b> to this account.

                <br /><br />
                <b>WARNING: All data associated with this tourist attraction will be lost permanently.</b>
            </span>, footer: [],
            withPassword: true
        });

        if(!returned) return;
        const password = returned.password;

        alert.alert("Deleting attraction...", { status: "progress" });

        try {
            await deleteAttraction(attraction.id, password);
            alert.alert("Attraction deleted successfully!");
        } catch(e) {
            console.log(e);
            const { title, message } = Exceptions.getARESemantics(e);
            alert.alert(message, { title, status: "error", retry: () => this.deleteAttraction(attraction) });
        }

        this.refresh(false);
    }
}


export async function addOrEditAttraction(attraction, { lgu, collection, lguFixed = false }) {
    return new Promise(async resolve => {
        const modifying = attraction ? true : false;
        const controller = {};

        const onChange = a => {
            attraction = { ...attraction, ...a };
        };
        
        const save = () => {
            resolve(attraction);
            controller.close();
        };
    
        await showModal({
            title: modifying ? "Edit Attraction" : "Add Attraction",
            width: 400,
            body: <AttractionFactory attraction={attraction} defaults={{ lgu }} lguFixed={lguFixed} collection={collection} onChange={onChange} />,
            footer: <div style={{ textAlign: "right" }}><Button icon="save" color="green" onClick={save}>SAVE</Button></div>
        }, controller);

        resolve();
    });
}


